<section class="t1">
    <section class="tabs-zone">
        <ng-content select="[tabs-zone]"></ng-content>
    </section>
    <section class="panel-zone">
        <ng-content select="[panel-zone]"></ng-content>
    </section>
</section>
